import './index.scss'
import fullpage from 'fullpage.js'
import 'fullpage.js/dist/fullpage.min.css'
import '../../assets/scripts/jquery.mousewheel'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'

$(document).ready(function(){
  if($(window).width() > 1024){
    initFullpage()
  }
})

$('.section1 select').on('change',function(){
  $(this).css('color','#085039')
})

//全屏滚动
var afullpage;
function initFullpage() {
  afullpage = new fullpage('#fullpage', {
    scrollingSpeed: 600,
    css3: true,
    resize:true,
    autoScrolling: true,
    scrollBar: false,
    anchors: ['page1', 'page2'],
		menu: '#menu',
    normalScrollElements: '.form-item .layui-anim',
    afterLoad: function (origin, destination, direction, trigger) {
      let i = destination.index;
      if(i == 1){
        afullpage.setAllowScrolling(false);
      }
    },
    onLeave: function (origin, destination, direction,trigger) {
    }
  });
}

$('#menu li').on('click',function(){
  afullpage.setAllowScrolling(true);
  $('.fixed-footer').removeClass('show')
})
//底部footer效果
function footerF(event, delta){
  let footerH = $('.fixed-footer').outerHeight()
  if(delta > 0){//返回，上滚
    if(!$('.fixed-footer').hasClass('show')){
      afullpage.setAllowScrolling(true);
    }else{
      $('.fixed-footer').removeClass('show')
      $('.footer-tran').css('transform','none')
      $('.trans-menu').css('transform','translateY(-50%)')
    }
  }else if(delta < 0){//下滚，显示footer
    if(!$('.fixed-footer').hasClass('show')){
      $('.fixed-footer').addClass('show')
      $('.footer-tran').css('transform','translateY('+ -footerH +'px)')
      $('.trans-menu').css('transform',' translateY(calc(-50% - '+ footerH +'px))')
    }
  }
  event.preventDefault();
}

if($(window).width() > 1024){
  $('#fullpage .section2').bind('mousewheel',function(event, delta) {
    footerF(event, delta)
  });
  $('.fixed-footer').mousewheel(function(event, delta) {
    if(delta > 0){//返回，上滚
      $('.fixed-footer').removeClass('show')
      $('.footer-tran').css('transform','none')
      $('.trans-menu').css('transform','translateY(-50%)')
    }
    event.preventDefault();
  });
}

// $('body').on('click',function(e){
//   setTimeout(function(){
//     if($('.layui-form-select').hasClass('layui-form-selected')){
//       afullpage.setAllowScrolling(false);
//     }else{
//       afullpage.setAllowScrolling(true);
//     }
//   },500)
// })

// let scrollh = 0
// $('.layui-anim-upbit').mousewheel(function(event, delta) {
//   console.log(scrollh)
//   scrollh += delta*100
//   $('.layui-anim-upbit').animate({scrollTop: scrollh})
//   event.preventDefault();
// });